<header
    class="p-2 text-center custom-nav"
  >
    <div class="">
      <div
        class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start"
      >
        <a
          href="/"
          class="d-flex align-items-center mb-2 mb-lg-0 text-white text-decoration-none"
        >
          <img
            src="assets/brand-logo.jpeg"
            class="bi ms-3 me-3 rounded-pill"
            [class.bg-light] = "themeService.themeState().bg === 'dark'"
            width="40"
            height="40"
            alt=""
          /><h2 class="text-dark me-5 brand-name my-auto brand-name">SaiRoadlines</h2>
        </a> 
        
      </div>
    </div>
  </header>

<div class="container mt-3">
  
<div *ngIf="booking; else noBooking">
  <div class="card shadow-sm p-3 mb-4 rounded-4">
    <h5 class="card-title mb-3">Booking Details</h5>
    <div class="row mb-2">
      <div class="col-md-6">
        <strong>Booking No:  </strong><span>{{ booking?.bookingId }}</span>
      </div>
      <div class="col-md-6">
        <strong>Status:  </strong>
        <tag [value]="booking?.status | uppercase" [classList]="booking.status | eventStatusBGPipe" [i]="false"></tag>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-6">
        <strong>Pickup Date:  </strong> {{ booking?.pickupAt | date: 'dd/MM/yyyy' }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-6">
        <strong>From:</strong> {{ booking?.fromCity?.city }}, {{ booking?.fromCity?.state }}
      </div>
      <div class="col-md-6">
        <strong>To:</strong> {{ booking?.toCity?.city }}, {{ booking?.toCity?.state }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-6">
        <strong>Material:</strong> {{ booking?.material }}
      </div>
      <div class="col-md-6">
        <strong>Quantity:</strong> {{ booking?.quantity }}
      </div>
    </div>
  </div>

  <div class="card shadow-sm p-3 rounded-4">
    <h5 class="card-title mb-3">Track Status</h5>
    
    @for (item of booking?.events; track $index) {
      <div class="m-3 ">
       @if (booking?.status !== item?.status || booking?.status === 'Delivered') {
        <fa-icon [icon]="faCheck" class="text-success"></fa-icon>
       }
        @if (booking?.status === item?.status && booking?.status !== 'Delivered') {
           <span class="spinner-grow spinner-grow-sm" role="status">
           </span>
         }
         <span class="ms-3">
           <tag [value]="item.status | uppercase" [classList]="item.status | eventStatusBGPipe" [i]="false" />
         </span>
         @if(item.status === 'Created'){
         <button 
          (click)="viewImage(booking)" 
          class="ms-2 btn btn-sm btn-outline-primary" 
          title="View Image">
          <fa-icon [icon]="faImage"></fa-icon>
        </button>
        
         }
         <br>
           <span class="vertical-line"></span>

           <span class="ms-3">{{item?.description}}</span>
           <br> 
           <span class="vertical-line"></span>
           <span class="ms-3">[{{item?.createdAt | date: 'dd/MM/yyyy hh:mm a'}}]</span>
         </div>
    }
  </div>
</div>

<ng-template #noBooking>
  <div class="text-center mt-4 text-muted">No Bookings Found.</div>
</ng-template>

</div>